import { CmsMeta } from '../cmsMeta';
import './CmsGrid.css';
import { ReactNode } from 'react';

type CmsGridProps = { size?: string; children: ReactNode };
export const CmsGrid = ({ children, size }: CmsGridProps): JSX.Element => {
	return <div className={size ? `cms-grid cms-grid--${size}` : 'cms-grid'}>{children}</div>;
};

export const cmsMeta: CmsMeta = {
	description: 'Lays its children out in a grid. Size is the number of columns, as a string.',
	example: [
		'CmsGrid',
		{ size: '2' },
		['CmsHtml', { content: '<p>Links</p>' }],
		['CmsHtml', { content: '<p>Rechts</p>' }],
	],
};
